import type { RouteStop } from "@/reducers/routes2gSlice"

const countPassthroughs = (stops: RouteStop[]) =>
  stops.filter((stop) => stop.action === "passthrough").length

// Whether the map should zoom to the whole route after the route changes
export function shouldShowEntireRouteOnUpdate(
  currentStops: RouteStop[],
  newStops: RouteStop[],
): boolean {
  // Nothing drawn yet (first load, or right after a room switch cleared the
  // map): always show the whole route
  if (currentStops.length === 0) return true
  // Re-fit when stops were added or removed, but not when a passthrough was
  // added by dragging the route line
  return (
    newStops.length !== currentStops.length &&
    countPassthroughs(newStops) === countPassthroughs(currentStops)
  )
}
